import { render, staticRenderFns } from "./PaymentNewCostComponent.vue?vue&type=template&id=d6588c28&scoped=true"
import script from "./PaymentNewCostComponent.vue?vue&type=script&lang=ts"
export * from "./PaymentNewCostComponent.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewCostComponent.vue?vue&type=style&index=0&id=d6588c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6588c28",
  null
  
)

export default component.exports